import pick from 'lodash/pick';

export const DISEASE = {
  MELANOMA: 'melanoma',
  MELANOMA_2: 'melanoma_2',
  CRC: 'crc',
  CLL: 'cll',
  BC: 'breast_cancer',
  MDS: 'mds',
  MPN: 'mpn',
  BLADDER: 'bladder',
  BLADDER_2: 'bladder_2',
  UTERINE: 'uterine',
  BRAIN: 'brain',
  MM: 'mm',
  LUNG: 'lung',
  BREAST_2: 'breast_2',
  NHL: 'nhl',
  CRC_2: 'crc_2',
  PROSTATE: 'prostate',
  AML: 'aml',
  HNSCC: 'hnscc',
  GI_TRACT: 'gi_tract',
  OVARIAN: 'ovarian',
  HCC: 'hcc',
  RCC: 'rcc_kidney',
  MESO: 'mesothelioma',
  GENERAL: 'general',
  CML: 'cml',
  SARCOMA: 'sarcoma',
  CERVICAL: 'cervical',
};

export const DISEASES = Object.values(DISEASE);

export const GENERAL_DISEASE = DISEASE.GENERAL;

export const GENERAL_DISEASE_SUB_TYPE = {
  PANCREATIC: 'pancreas',
  TESTICULAR: 'testicular_cancer',
};

export const OTHER_DISEASE = 'other_cancer';

// subset of allCancerTypes by the next criteria:
// - supported cancer types (melanoma, crc, bladder are excluded)
// - with bundled questionnaire (questionnaire is not from the server)
export const BUNDLED_DISEASE = pick(DISEASE, [
  'AML',
  'BLADDER_2',
  'BRAIN',
  'BREAST_2',
  'CLL',
  'CRC_2',
  'GI_TRACT',
  'HCC',
  'HNSCC',
  'LUNG',
  'MDS',
  'MELANOMA_2',
  'MM',
  'MPN',
  'NHL',
  'OVARIAN',
  'PROSTATE',
  'UTERINE',
]);

const diseaseNameTranslationKeyByCancerTypes = Object.values(BUNDLED_DISEASE).reduce((translateKeys, cancerType) => {
  // eslint-disable-next-line no-param-reassign
  translateKeys[cancerType] = `disease_name.cancer_types.${cancerType}`;
  return translateKeys;
}, {});

// bundled and supported
export const BUNDLED_DISEASE_OPTIONS = Object.keys(diseaseNameTranslationKeyByCancerTypes).map((key) => ({
  label: diseaseNameTranslationKeyByCancerTypes[key],
  value: key,
}));
